import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { TitleProps } from 'Components/frameworks/title/Title';
import { Title } from 'Components/frameworks/title/Title';
type Props = TitleProps;
export const LineTitle = ({ className, ...rest }: Props) => (
  <Title {...rest} className={classnames('mb-20', className)} theme="title-brand-n1" />
);
